import whatsappIcon from './../../assets/icons/contact/whatsapp.svg';
import messengerIcon from './../../assets/icons/contact/messenger.svg';
import mailIcon from './../../assets/icons/contact/mail.svg';
import phoneIcon from './../../assets/icons/contact/phone.svg';


export const ContactsResources = {
    whatsappIcon, messengerIcon, mailIcon, phoneIcon
}